import React, { useState } from "react";
import { UNCONFIRMED_LABEL } from "../copy/decisionReviewCopy";
import { BRAIN_CATEGORIES, brainCategoryLabel } from "../guides/companyBrain";
import StatusBadge from "../ui/StatusBadge";

export function plainFindingText(text) {
  return String(text || "")
    .replace(/<[^>]+>/g, "")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/`([^`]*)`/g, "$1")
    .replace(/`+/g, "")
    .trim();
}

function MaybeMarkdown({ text }) {
  const plain = plainFindingText(text);
  if (!plain) return null;
  return <p>{plain}</p>;
}

export default function DecisionReviewFinding({ finding, disposition, onFeedback, stale }) {
  const [open, setOpen] = useState(false);
  const [correcting, setCorrecting] = useState(false);
  const [correction, setCorrection] = useState(finding.productImpact || finding.explanation || "");
  const [reason, setReason] = useState("irrelevant");
  const evidence = finding.evidence || [];
  return (
    <article className="rr-finding">
      <div className="rr-meta">
        <StatusBadge tone={finding.contextState === "Confirmed" ? "ok" : "warn"}>{finding.contextState || UNCONFIRMED_LABEL}</StatusBadge>
      </div>
      <h3>{finding.title}</h3>
      <MaybeMarkdown text={finding.explanation} />
      {finding.productImpact || finding.contextTitle ? (
        <p>
          {finding.contextState === "Confirmed" ? "Your Company Brain says: " : "Existing product behavior suggests: "}
          “{finding.productImpact || finding.contextTitle}”
        </p>
      ) : null}
      <p>Context: {finding.contextState || "Inferred"}{BRAIN_CATEGORIES.some((item) => item.value === finding.category) ? ` · ${brainCategoryLabel(finding.category)}` : ""}{finding.contextId ? ` · ${finding.contextId}` : ""}</p>
      {evidence[0]?.path ? <p>Evidence: {evidence[0].path}{evidence[0].line ? `:${evidence[0].line}` : ""}</p> : null}
      {evidence[0]?.excerpt ? <pre className="rr-sha">{evidence[0].excerpt}</pre> : null}
      {finding.proposedAction ? <p>Next: {finding.proposedAction}</p> : null}
      <button type="button" className="rr-text-button" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
        {open ? "Hide evidence" : "Show evidence"}
      </button>
      {open ? (
        <div>
          {evidence.map((item, index) => (
            <pre key={`${item.path || "evidence"}-${index}`} className="rr-sha">
              {item.excerpt || "No diff excerpt was stored."}
            </pre>
          ))}
          {finding.contextTitle ? <p>Context used: {finding.contextTitle}</p> : null}
          {finding.uncertainty ? <p>{finding.uncertainty}</p> : null}
        </div>
      ) : null}
      {disposition ? <p>{disposition}</p> : null}
      {correcting ? (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            onFeedback?.(finding, { action: "correct_context", title: finding.contextTitle || finding.title, body: correction });
            setCorrecting(false);
          }}
        >
          <label>
            Corrected rule
            <textarea value={correction} onChange={(event) => setCorrection(event.target.value)} rows={3} />
          </label>
          <button type="submit" className="rr-button" disabled={stale}>Save to Company Brain</button>
        </form>
      ) : null}
      <div className="rr-actions">
        <button type="button" className="rr-text-button" disabled={stale} onClick={() => onFeedback?.(finding, { action: "confirm_issue" })}>
          Confirm issue
        </button>
        <label>
          Not an issue because
          <select value={reason} onChange={(event) => setReason(event.target.value)} disabled={stale}>
            <option value="wrong_context">Wrong context</option>
            <option value="incorrect_interpretation">Incorrect code interpretation</option>
            <option value="intentional_exception">Intentional exception</option>
            <option value="irrelevant">Irrelevant finding</option>
          </select>
        </label>
        <button type="button" className="rr-text-button" disabled={stale} onClick={() => onFeedback?.(finding, { action: "not_an_issue", reason })}>
          Not an issue
        </button>
        <button type="button" className="rr-text-button" disabled={stale} onClick={() => setCorrecting(true)}>
          Correct Company Brain
        </button>
        <button type="button" className="rr-text-button" disabled={stale} onClick={() => onFeedback?.(finding, { action: "save_guide" })}>
          Confirm this context
        </button>
      </div>
    </article>
  );
}
